import styles from './ArticleDetails.module.scss';
import { Link, useParams } from 'react-router-dom';
import { FaCalendarAlt, FaRegClock, FaAngleLeft } from 'react-icons/fa';

// dane
import { articles } from '../../../data/article';

const ArticleDetails = () => {
  const { id } = useParams();
  const article = articles.find((article) => article.id === Number(id));
  return (
    <article className={styles.container}>
      <Link to='/articles'>
        <div className={styles.back}>
          <span>
            <FaAngleLeft />
          </span>
          <p> Powrót</p>
        </div>
      </Link>
      {/* loops  */}
      {article && (
        <div key={article.id} className={styles.content}>
          <header className={styles.header}>
            <h1>{article.title}</h1>

            <div className={styles.meta}>
              <div className={styles.metaItem}>
                <span>
                  <FaCalendarAlt />
                </span>
                <time dateTime=''>{article.date}</time>
              </div>

              <div className={styles.metaItem}>
                <span>
                  <FaRegClock />
                </span>
                <p>{article.readTime}</p>
              </div>

              <div className={styles.metaItem}>
                <p>Autor:</p>
                <p className={styles.author}>{article.author}</p>
              </div>
            </div>
          </header>
          <hr className={styles.separator} />
          {article.sections.map((section, index) => (
            <section key={index}>
              {section.type === 'h2' && <h2> {section.text}</h2>}
              {section.type === 'p' && <p>{section.text}</p>}
            </section>
          ))}
          {article.bibliography && (
            <section className={styles.bibliography}>
              <h4>Bibliografia:</h4>
              <ul>
                {article.bibliography.map((item, index) => (
                  <li key={index}> {item}</li>
                ))}
              </ul>
            </section>
          )}
        </div>
      )}
    </article>
  );
};

export default ArticleDetails;
